import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import AssessmentIcon from '@mui/icons-material/Assessment';

interface Props {
    eventId: string;
}

export default function ReportsScreenLink(props: Props) {
    const navigate = useNavigate();

    const handleGenerateReport = () => {
        navigate(`/event/${props.eventId}/reports`);
    };

    return (
        <Button variant="contained" onClick={handleGenerateReport} startIcon={<AssessmentIcon />}>
            Report Generation
        </Button>
    );
}
